import { useWSAnalytics } from "../../../utils/WSAnalytics";
import pick from "lodash/pick";
import { WSNotificationResponse } from "../components/Notifications";

export const useTrackClickNotification = (userId: string) => {
  const { track } = useWSAnalytics();

  return (notification: WSNotificationResponse) => {
    track.other("Notification Clicked", {
      userId,
      ...pick(
        notification,
        "notificationId",
        "channelMessageId",
        "type",
        "context",
        "priority",
        "handle",
        "subject"
      )
    });
  };
};
